import common from './constants/common';
import supportedBlockIds from './constants/supported-block-ids';
import addAndConvertToGroupControl from './controls/add-and-convert-to-group-control';
import addCompositeItemControl from './controls/add-composite-item-control';
import reorderLayersControl from './controls/reorder-layers-control';

const extension = {
  slug: common.slug,
  title: 'WS Composite Group extensions',
  description: 'Extension to setup composite group',
  defaults: {
    querySelector: 'ws-composite-group, ws-composite-item',
    elementToReorderSelector: 'ws-composite-item',
    supportedBlockIds,
  },
  ui: {
    control: [addAndConvertToGroupControl, addCompositeItemControl, reorderLayersControl],
  },
};

export default extension;
